import HubspotForm from '@/components/ui/hubspot-form'

import { cx } from '@/utils/strings'
import { useTranslations } from '@/utils/locale'
import { useState } from 'react'

const HUBSPOT_FORM_ID = 'e1794cd8-cd90-4bac-9b2d-06d0b8589eaa'

type LeadCaptureFormProps = {
  className?: string
  note?: string
  variant?: 'container' | 'contents'
  onSubmit?: () => void
}

export default function LeadCaptureForm({ className, note, variant = 'container', onSubmit }: LeadCaptureFormProps) {
  const { t } = useTranslations()
  const [showHeading, setShowHeading] = useState(true)

  return (
    <div
      className={cx(
        'space-y-2',
        variant === 'container' &&
          cx(
            'bg-gradient-to-br from-primary-100 to-primary-300 dark:from-primary-900/20 dark:to-primary-800/20',
            'border border-primary-200 dark:border-primary-700 rounded-lg p-3'
          ),
        className
      )}
    >
      {showHeading && (
        <div className="space-y-0.5">
          <h3
            className={cx(
              'text-sm font-semibold',
              variant === 'container' && 'text-gray-900 dark:text-white',
              variant === 'contents' && 'text-white'
            )}
          >
            {t('Ready to talk to sales?')}
          </h3>
          <p
            className={cx(
              'text-xs',
              variant === 'container' && 'text-gray-600 dark:text-gray-300',
              variant === 'contents' && 'text-white'
            )}
          >
            {t('Get a personalized demo tailored to your needs.')}
          </p>
        </div>
      )}

      <HubspotForm
        internalName="AI Chat Lead Capture"
        formId={HUBSPOT_FORM_ID}
        submitText={t('Submit')}
        defaultValues={note ? { message: note } : undefined}
        className={cx(
          '[&_input:not([type=submit])]:h-9! [&_input:not([type=submit])]:text-sm! [&_textarea]:text-sm!',
          '[&_select]:h-9! [&_select]:text-sm! [&_select]:px-3! [&_select]:py-0!',
          '[&_label]:pb-1! [&_label]:text-xs!',
          '[&_.input]:mr-0! [&_input]:text-black',
          '[&_.hs-form-field]:mb-2!',
          '[&_.hs-fieldtype-textarea]:min-h-20!',
          '[&_.hs-form-checkbox-display_span]:text-xs! [&_.hs-form-checkbox-display_span]:leading-4!',
          '[&_.legal-consent-container_ul]:my-2!',
          '[&_.hs_error_rollup]:pb-2!',
          '[&_.hs-button]:text-sm! [&_.hs-button]:px-4! [&_.hs-button]:py-2!',
          '[&_.form-columns-2_*]:w-full!',
          '[&_.submitted-message]:text-sm! [&_.submitted-message]:leading-5!'
        )}
        onSubmit={() => {
          if (onSubmit) {
            onSubmit()
          }
          setShowHeading(false)
          if (typeof window.plausible !== 'undefined') {
            window.plausible('AI Chat Lead Capture Form Submitted')
          }
        }}
      />
    </div>
  )
}
